import { BankInfoTextModule } from './../bank-info-text/bank-info-text.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogDepositComponent } from './dialog-deposit.component';
import { CpfCnpjPipeModule } from '@toro/common/shared/pipes';
import { SvgIconModule } from '@toro/common/shared/components';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatStepperModule } from '@angular/material/stepper';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { QRCodeModule } from 'angularx-qrcode';
import { TrSpinnerButtonDirectiveModule } from '@toro/common/shared/directives';

@NgModule({
  declarations: [
      DialogDepositComponent,
  ],
  imports: [
    CommonModule,
    CpfCnpjPipeModule,
    BankInfoTextModule,
    SvgIconModule,
    MatStepperModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    CurrencyMaskModule,
    QRCodeModule,
    TrSpinnerButtonDirectiveModule,
  ],
  exports: [
      DialogDepositComponent
  ],
  entryComponents: [ DialogDepositComponent ],
})
export class DialogDepositModule { }
